import { Attributes, NeoModel } from '@singularsystems/neo-core';
import AuditLookup from 'st-common/App/Models/Audit/AuditLookup';
import ApprovalLookup from './ApprovalLookup';

@NeoModel
export default class ApprovalAuditLookup extends AuditLookup {

    @Attributes.ChildObject(ApprovalLookup)
    public entity: ApprovalLookup = new ApprovalLookup();
}